import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M17.5 13.5H6.5C5.671 13.5 5 12.829 5 12C5 11.171 5.671 10.5 6.5 10.5H17.5C18.328 10.5 19 11.171 19 12C19 12.829 18.328 13.5 17.5 13.5Z"
      fill="currentColor"
    />
    <path
      d="M14.8 19.2H9.19995C8.37095 19.2 7.69995 18.528 7.69995 17.7C7.69995 16.872 8.37095 16.2 9.19995 16.2H14.8C15.628 16.2 16.3 16.872 16.3 17.7C16.3 18.528 15.628 19.2 14.8 19.2Z"
      fill="currentColor"
    />
    <path
      d="M20.5 7.80005H3.5C2.671 7.80005 2 7.12805 2 6.30005C2 5.47205 2.671 4.80005 3.5 4.80005H20.5C21.328 4.80005 22 5.47105 22 6.30005C22 7.12905 21.328 7.80005 20.5 7.80005Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Filter');

export default Icon;
